import GetStarted from './get-started'

export default GetStarted
